import axiosClient from "../lib/api/axiosClient";
const endpoint_two = process.env.REACT_APP_API_ENDPOINT_TWO;
const endpoint_one = process.env.REACT_APP_API_ENDPOINT_ONE;
const api_version = process.env.REACT_APP_API_VERSION;

export default {
  getCBTSetUp: (token, schoolId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/CBT/CbtSetups?schoolId=${schoolId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  getTypes: (token) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/CBT/CbtTypes`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  deleteCBTSetUp: (token, Id) =>
    axiosClient
      .delete(
        `${endpoint_two}/api/v${api_version}/CBT/Delete-Cbt-Setup?Id=${Id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  addCBTSetUp: (token, data) =>
    axiosClient
      .post(`${endpoint_two}/api/v${api_version}/CBT/Add-Cbt-SetUp`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  updateCBTSetUp: (token, data, id) =>
    axiosClient
      .put(`${endpoint_two}/api/v${api_version}/CBT/Update-Cbt-SetUp/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  addCBTQuestions: (token, data) =>
    axiosClient
      .post(`${endpoint_two}/api/v${api_version}/CBT/Add-Question`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  updateCBTQuestions: (token, data) =>
    axiosClient
      .put(`${endpoint_two}/api/v${api_version}/CBT/update-Question`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  addCBTAttachment: (token, data) =>
    axiosClient.post(
      `${endpoint_two}/api/v${api_version}/CBT/UploadAttachment`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => res.data)
      .catch((err) => err.response),

  deleteCBTAttachment: (token, Id) =>
    axiosClient
      .delete(
        `${endpoint_two}/api/v${api_version}/CBT/Delete-Attachment/${Id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  activateDeactive: (token, Id, type) =>
    axiosClient
      .patch(
        `${endpoint_two}/api/v${api_version}/CBT/Activate-Cbt-Setup/${Id}?activate=${type}`,
        {}, // empty body
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),


  getCBTQuestionsList: (token, schoolId, subjectId, setupId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/CBT/QuestionsList?schoolId=${schoolId}&subjectId=${subjectId}&setupId=${setupId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  getCBTQuestionDetails: (token, schoolId, Id) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/CBT/QuestionDetails?Id=${Id}&schoolId=${schoolId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  getCBTQuestions: (token, schoolId, subjectId, setupId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/CBT/CbtQuestions?schoolId=${schoolId}&subjectId=${subjectId}&setupId=${setupId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  deleteCBTQuestion: (token, Id) =>
    axiosClient
      .delete(
        `${endpoint_two}/api/v${api_version}/CBT/Delete-CbtQuestion?Id=${Id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  assignClasses: (token, data) =>
    axiosClient
      .post(`${endpoint_two}/api/v${api_version}/CBT/Assgin-Classes`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  ViewCBTSubmission: (token, setupId) =>
    axiosClient
      .get(
        `${endpoint_one}/api/v${api_version}/StudentCbt/View-Submission/${setupId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  getCBTSubmission: (token, setupId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/CBT/SubmittedCbts?setupId=${setupId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data),

  getCBTSubmissionList: (token, setupId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/CBT/Students/SubmittedCbt/${setupId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data),

  getCBTSubmissionDetails: (token, setupId, studentId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/CBT/submittedCBTDetails?studentId=${studentId}&setupId=${setupId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  getAssignClasses: (token, schoolId, setupId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/CBT/getAssignClasses?setupId=${setupId}&schoolId=${schoolId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

}
